module.exports = __webpack_public_path__ + "media/application/images/projects/images/egypt-f75ff7400bd3774c0b8ef00fc05cbf6d.jpg";